module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/team-injuries/team-injuries.component.html
// module id = ./src/app/pages/team-injuries/team-injuries.component.html
// module chunks = main